export const ownerOption = [
  { value: 'OWNER', label: 'OWNER' },
  { value: 'EMPLOYEE', label: 'EMPLOYEE' },
  { value: 'CONTRACTOR', label: 'CONTRACTOR' },
  { value: 'SUPPLIER', label: 'SUPPLIER' },
];

export const partnerOption = [
  { value: 'OWNER', label: 'OWNER' },
  // { value: 'MANAGER', label: 'MANAGER' },
  // { value: 'EMPLOYEE', label: 'EMPLOYEE' },
  // // { value: 'PARTNER', label: 'PARTNER' },
  // // { value: 'CORPORATE ADMIN', label: 'CORPORATE ADMIN' },
  // { value: 'VISITOR', label: 'VISITOR' },
];

export const visitorOption = [
  { value: 'OWNER', label: 'OWNER' },
  { value: 'VISITOR', label: 'VISITOR' },
];
